import { Box, Row } from "@tokenterminal/ui/Box"
import { LinkButtonV4 } from "@tokenterminal/ui/Button/LinkButton.v4"
import { Card } from "@tokenterminal/ui/Card/Card"
import { Heading } from "@tokenterminal/ui/Heading"
import { LinkText } from "@tokenterminal/ui/Link/Link"
import { Stack } from "@tokenterminal/ui/Stack"
import { Text } from "@tokenterminal/ui/Text"
import Container from "../common/Container"
import Layout from "../common/Layout"
import MarketingHeading from "../common/MarketingHeading"
import CustomerGrid from "../home/CustomerGrid"
import { ProductsList } from "../home/SolutionsForEveryScale"
import { productsContainerCss } from "../products/common.css"
import PricingCards from "./PricingCards"
import { headingCss } from "./PricingPage.css"
import PricingTable from "./PricingTable"

const faqData = {
  faq1: {
    question: "How do I get an API key?",
    answer: (
      <Text>
        <LinkText
          style={{ fontSize: "inherit" }}
          href="/explorer/account/billing"
        >
          Sign up
        </LinkText>{" "}
        for our API plan in your {`organization's`} billing page. After you
        subscribe to the Token Terminal API, you will find your API key on both
        the{" "}
        <LinkText
          style={{ fontSize: "inherit" }}
          href="https://docs.tokenterminal.com/reference/"
          className="default-text-size"
        >
          API reference
        </LinkText>{" "}
        and on your personal{" "}
        <LinkText
          style={{ fontSize: "inherit" }}
          href="/explorer/account/api"
          className="default-text-size"
        >
          account page
        </LinkText>
        .
      </Text>
    ),
  },
  faq2: {
    question: "Can I talk to someone from the team?",
    answer: (
      <Text>
        Yes, send us an email at{" "}
        <LinkText
          style={{ fontSize: "inherit" }}
          href="mailto:people@tokenterminal.xyz"
          className="default-text-size"
        >
          people@tokenterminal.xyz
        </LinkText>
        .
      </Text>
    ),
  },
  faq3: {
    question: "How do I get an invoice for my subscription?",
    answer: (
      <Text>
        Reach out to{" "}
        <LinkText
          style={{ fontSize: "inherit" }}
          href="mailto:people@tokenterminal.xyz"
          className="default-text-size"
        >
          finance@tokenterminal.xyz
        </LinkText>{" "}
        and we’ll email you the invoice.
      </Text>
    ),
  },
  faq4: {
    question: "Where can I find your terms of service?",
    answer: (
      <Text>
        We make use of a standard set of general terms that apply to all of our
        users. You can find them here:{" "}
        <LinkText
          style={{ fontSize: "inherit" }}
          href="https://tokenterminal.com/docs/terms"
          className="default-text-size"
        >
          tokenterminal.com/docs/terms
        </LinkText>
        .
      </Text>
    ),
  },
  faq5: {
    question: "Can I get access for my team?",
    answer: (
      <Text>
        Yes, we offer team-wide subscriptions. Invite team members from your{" "}
        <LinkText
          style={{ fontSize: "inherit" }}
          href="/explorer/account/"
          className="default-text-size"
        >{`organization's`}</LinkText>{" "}
        settings page. You will be charged monthly for each user you add to your
        team.
      </Text>
    ),
  },
  faq6: {
    question: "Can I cancel my subscription anytime?",
    answer: (
      <Text>
        Yes, you can cancel your subscription at any time, and it will remain
        active until the end of the current billing cycle, which is either the
        end of month or year, depending on the subscription. The subscription
        will not automatically renew. You will not incur any additional charges,
        unless you decide to purchase a new subscription.
      </Text>
    ),
  },
}

const PricingPage = () => {
  return (
    <Layout>
      <Stack
        justifyContent="flexStart"
        style={{
          position: "relative",
          width: "100%",
        }}
      >
        <Container
          as={Stack}
          gap="12x"
          alignItems="center"
          style={{
            paddingTop: "100px",
            textAlign: "center",
            position: "relative",
          }}
        >
          <Stack gap="8x">
            <Heading level={1} className={headingCss} marginBottom="1x">
              Choose your plan
            </Heading>
            <Text
              size="16"
              color="muted"
              style={{
                width: "500px",
                maxWidth: "100%",
              }}
            >
              Access historical data with a free account. Upgrade to download
              data, use Sheets, create unlimited dashboards, build on our API,
              or integrate with our Data Warehouse.
            </Text>
          </Stack>
        </Container>
      </Stack>
      <Container
        style={{ paddingTop: "100px", paddingBottom: "50px" }}
        alignItems="center"
        justifyContent="center"
      >
        <PricingCards />
      </Container>
      <Container style={{ paddingTop: "100px", paddingBottom: "50px" }}>
        <PricingTable />
      </Container>
      <Container>
        <Card
          padding="7x"
          style={{
            marginTop: "20px",
            border: "1px solid #222",
            borderRadius: "16px",
            background: "#121212",
          }}
        >
          <Row justifyContent="spaceBetween" width="100%">
            <Stack gap="1x">
              <Text fontWeight="500">Need a custom plan for your team?</Text>
              <Text size="14" style={{ color: "#999" }}>
                We offer tailored solutions for teams.
              </Text>
            </Stack>
            <LinkButtonV4 variant="outline" href="/contact">
              Contact sales
            </LinkButtonV4>
          </Row>
        </Card>
      </Container>
      <Container className={productsContainerCss}>
        <Row justifyContent="center" marginBottom="10x">
          <MarketingHeading level={2}>
            Learn more about our products
          </MarketingHeading>
        </Row>
        <ProductsList />
      </Container>
      <Container paddingY="10x">
        <CustomerGrid />
      </Container>
      <Container style={{ padding: "100px 0" }}>
        <Stack alignItems="center">
          <MarketingHeading level={2} marginBottom="12x" textAlign="center">
            The most common questions
          </MarketingHeading>
          <Stack gap="4x">
            {Object.values(faqData).map((faq, index) => (
              <Card
                key={index}
                padding="6x"
                style={{
                  borderRadius: "16px",
                  background: "#121212",
                  position: "relative",
                }}
              >
                <Stack gap="3x">
                  <Text size="16" fontWeight="500">
                    {faq.question}
                  </Text>
                  <Box color="muted">{faq.answer}</Box>
                </Stack>
              </Card>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Layout>
  )
}

export default PricingPage
